import axios from 'axios'
import React, { useEffect, useState } from 'react'
import NavigatorCardsModel from '../../../../../../../navigatorCardsModel/NavigatorCardsModel'
import TitleHeader from '../../../../../../../smallComponents/Header'
import Loading from '../../../../../../../smallComponents/Loading'
import i18next from 'i18next'

const ResearchdevelopmentChannels = ({ DCGProps, activity }) => {
  const [channels, setChannels] = useState([])
  const lang = i18next.language
  const rtl = lang === 'ar'
  const [isLoading, setIsLoading] = useState(true)
  useEffect(() => {
    const fetchUdeaPosts = async () => {
      setIsLoading(true)
      try {
        const resChannels = await axios.get(
          `/channels/elementChannels/${activity?._id}`
        )
        setChannels(resChannels.data.channels)
      } catch (error) {
        console.log(error)
      }
      setIsLoading(false)
    }
    fetchUdeaPosts()
  }, [activity?._id])
  return isLoading ? (
    <Loading />
  ) : (
    channels?.length > 0 && (
      <>
        <TitleHeader headerText={rtl ? 'قنوات' : 'Channels'} />
        <NavigatorCardsModel
          unitsArray={channels}
          {...DCGProps}
          modelUnitProps={{
            imageKey: 'channel',
            windowProps: {
              windowCardName: 'channel',
              windowType: 'channel',
              DCGProps,
            },
          }}
        />
      </>
    )
  )
}

export default ResearchdevelopmentChannels
